angular.module('dpw.components').directive('dpwCancelTrial', [function () {
    return {
        restrict: 'A',
        scope: true,
        controllerAs: 'ctrl',
        templateUrl: 'dpw-cancel-trial.component.html',
        controller: ['$scope', 'api', function ($scope, api) {
            var self = this;

            self.cancel = function () {
                $scope.onClose && $scope.onClose();
            };

            self.confirm = function () {
                api.call(api.devTrialUser.cancel(), function () {
                    window.location.href = '/?trialCancelled=true';
                });
            };
        }]
    };
}]);
